import React from 'react';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import { PANEL_SX } from './OverviewPanel';

interface Props {
	label: string;
	value: React.ReactNode;
	caption?: string;
	secondary?: string;
	loading?: boolean;
	/** Colour of the big value, e.g. 'error.main' when a limit is exceeded. */
	valueColor?: string;
}

/** One headline number with a label above and captions below; shares the overview card look. */
export default function StatTile({ label, value, caption, secondary, loading, valueColor }: Props) {
	return (
		<Paper elevation={0} sx={{ ...PANEL_SX, p: 2, height: '100%' }}>
			<Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
				{label}
			</Typography>
			{loading ? (
				<Skeleton width={80} height={40} />
			) : (
				<Typography variant="h4" sx={{ fontWeight: 600, lineHeight: 1.2, my: 0.5, color: valueColor }}>
					{value}
				</Typography>
			)}
			{caption && (
				<Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
					{caption}
				</Typography>
			)}
			{secondary && (
				<Typography variant="caption" sx={{ display: 'block' }}>
					{secondary}
				</Typography>
			)}
		</Paper>
	);
}
